<template>
  <div >
    <Row style="margin-left:0;" type="flex" justify="space-between" >
      <Col span="12" class="changeCol">
        <Card :padding='0' dis-hover>
          <p slot="title">基础积分</p>
          <div class="jifenCard">
            <div>{{jifenRes.shimingTitle}}</div>
            <div class="changeInput box">
              <Input placeholder="请输入实名认证分数" v-model="inputNum" ></Input>
              <div class="danwei">分</div>
            </div>
          </div>
        </Card>
      </Col>
      <Col span="12" class="changeCol">
        <Card :padding='0' dis-hover>
          <p slot="title">活动积分</p>
          <div class="jifenCard box">
            <div class="box_f1">
              <div>党员积分比例</div>
              <div class="changeInput box">
                <Input placeholder="请输入党员积分百分比" v-model="inputBaifenbi" ></Input>
                <div class="danwei">%</div>
              </div>
            </div>
            <div class="box_f1">
              <div>居民积分比例</div>
              <div class="changeInput box">
                <Input placeholder="请输入居民积分百分比" v-model="inputJumin" ></Input>
                <div class="danwei">%</div>
              </div>
            </div>
          </div>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
  var that
  export default {
    props: {
      jifenRes:{
        type:Object,
        default:{}
      },
      changeLoading: {
        type:Boolean,
        default: false
      }
    },
    components: {
    },
    watch: {
      changeLoading (newValue, oldValue) {
        if (this.changeLoading) {
          this.submitChange()
        }
      }
    },
    data () {
      return {
        inputNum:'',
        inputBaifenbi:'',
        inputJumin:''
      }
    },
    methods: {
      submitChange () {
        console.log('提交')
        var jifen = parseInt(that.inputNum)
        var baifenbi = parseInt(that.inputBaifenbi)
        var jumin = parseInt(that.inputJumin)
        if (typeof(jifen)  === 'number' && jifen%1 === 0 && typeof(baifenbi)  === 'number' && baifenbi%1 === 0 && baifenbi <= 100 && typeof (jumin) === 'number' && jumin %1 === 0 && jumin <=100) {
          var subJf = this.submitJifen()
          var subBfb =  this.submitBaifenbi()
          Promise.all([subJf,subBfb]).then(res => {
            res.forEach(item => {
              if (!item.isSucceed) {
                that.$Message.error('提交失败')
                that.$emit('closeLoading')
                return
              }
            })
            that.$Message.success('提交成功')
            that.$emit('submitSuccess')
          })
        }else {
          that.$Message.warning('积分必须为整数 百分比不大于100')
          that.$emit('closeLoading')
        }
      },
      submitJifen () {
        return new Promise((resolve , reject) => {
          var url = that.urlobj.submitJifen
          that.$post(url,{
            "score" : that.inputNum*100,
            "scoreType" : "realname",
            "scoreUpper" : that.inputNum*100,
            "limitUpper" : 1,
            "scoreMultiple" : 1,
            "remark" : "实名认证"
          }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e.message)
          })
        })
      },
      submitBaifenbi () {
        return new Promise((resolve , reject) => {
          var url = that.urlobj.submitBaifenbi
          that.$post(url,{
            percent: parseInt(that.inputBaifenbi),
            percentResident:parseInt(that.inputJumin)
          }).then(res => {
            resolve(res)
          }).catch(e => {
            reject(e.message)
          })
        })
      }
    },
    mounted () {
      that = this
      this.inputNum = this.jifenRes.shimingScore
      this.inputBaifenbi = this.jifenRes.baifenbi
      this.inputJumin = this.jifenRes.jumin
    }
  }
</script>

<style scoped>
  .changeCol{
    padding: 0 10px 30px 10px
  }
  .jifenCard{
    padding:16px;
  }
  .changeInput{
    width: 370px;
    margin-top:30px;
    justify-content: center;
    align-items: center;
  }
  .danwei{
    margin-left:10px;
  }
</style>
